// extracted by mini-css-extract-plugin
module.exports = {"ambassadors":"Ambassadors_ambassadors__79X1u"};